const PackageAPIURL = {
  //#region Package
  GetPackageList: 'api/Package/GetPackageList',
  GetPackageDetailsById: 'api/Package/GetPackageDetailsById',
  AddUpdatePackage: 'api/Package/AddUpdatePackage',
  DeletePackageById: 'api/Package/DeletePackageById',
  UpdateMappedByPackageId: 'api/Package/UpdateMappedByPackageId',
  GetPackageItineraryDetails: 'api/Report/GetPackageItineraryDetails',
  GetPackageItineraryPDF: 'api/Itinerary/GetPackageItineraryPDF',
  GetPackageItineraryDoc: 'api/Itinerary/GetPackageItineraryDoc',
  CopyPackage: 'api/Package/CopyPackage',
  //#endregion

  //#region package Image
  GetPackageImageList: 'api/Package/GetPackageImages',
  //#endregion

  //#region package Cost and Discount
  GetPackageCostDiscountList: 'api/Package/GetPackageCostDiscountList',
  AddUpdatePackageCostDiscount: 'api/Package/AddUpdatePackageCostDiscount',
  PackageCostDiscountIsDefault: 'api/Package/PackageCostDiscountIsDefault',
  DeletePackageCostDiscount: 'api/Package/DeletePackageCostDiscount',
  //#endregion

  //#region package Itinerary
  GetPackageItineraryList: 'api/Package/GetPackageItineraryList',
  AddUpdatePackageItinerary: 'api/Package/AddUpdatePackageItinerary',
  DeletePackageItinerary: 'api/Package/DeletePackageItinerary',

  GetItineraryDateList: 'api/Package/GetItineraryDateList',
  AddUpdateItineraryDate: 'api/Package/AddUpdateItineraryDate',
  //#endregion

  //#region Inclusion,Exclusion,TraveGuide, AdditionalNotes
  GetPackageContentDetails: 'api/Package/GetPackageContentDetails',
  AddUpdatePackageContentDetails: 'api/Package/AddUpdatePackageContentDetails',
  //#endregion

  //#region RoadDistance
  GetPackageRoadDistanceList: 'api/Package/GetPackageRoadDistanceList',
  AddUpdatePackageRoadDistance: 'api/Package/AddUpdatePackageRoadDistance',
  DeletePackageRoadDistance: 'api/Package/DeletePackageRoadDistance',
  //#endregion

  //#region Hotel
  GetPackageHotelList: 'api/Package/GetPackageHotelList',
  GetPackageHotelDetails: 'api/Package/GetPackageHotelDetails',
  AddUpdatePackageHotel: 'api/Package/AddUpdatePackageHotel',
  //#endregion

  //#region Flight
  GetPackageFlightList: 'api/Package/GetPackageFlightList',
  AddUpdatePackageFlight: 'api/Package/AddUpdatePackageFlight',
  DeletePackageFlight: 'api/Package/DeletePackageFlight',
  //#endregion

  //#region HomeSlider
  GetHomeSliderList: 'api/Package/GetHomeSliderList',
  AddUpdateHomeSlider: 'api/Package/AddUpdateHomeSlider',
  DeleteHomeSliderById: 'api/Package/DeleteHomeSliderById',
  //#endregion

  //#region Destination Hot
  GetDestinationHotList: 'api/Package/GetDestinationHotList',
  AddUpdateDestinationHot: 'api/Package/AddUpdateDestinationHot',
  //#endregion

  //#region Destination Hot
  GetBestTourPackages: 'api/Package/GetBestTourPackages',
  AddUpdateBestTourPackages: 'api/Package/AddUpdateBestTourPackages',
  //#endregion

  //#region ReportingDropingPoint
  GetPackageReportingDropingPointList: 'api/Package/GetPackageReportingDropingPointList',
  AddUpdatePackageReportingDropingPoint: 'api/Package/AddUpdatePackageReportingDropingPoint',
  DeletePackageReportingDropingPoint: 'api/Package/DeletePackageReportingDropingPoint',
  //#endregion

  //#region Destination Hot
  GetHomeBlogOthers: 'api/Package/GetHomeBlogOthers',
  AddUpdateHomeBlogOthers: 'api/Package/AddUpdateHomeBlogOthers',
  //#endregion

  //#region Destination Hot
  GetTrendingPackages: 'api/Package/GetTrendingPackages',
  AddUpdateTrendingPackage: 'api/Package/AddUpdateTrendingPackage',
  //#endregion
}
export default PackageAPIURL;